import { useState } from 'react';

import Checkbox from '@ingka/checkbox';
import { translate } from '@repo/phrase';
import { Paragraph } from '@repo/ui/typography';
import { getCountryLanguage } from '@repo/utils';

import { DialogModal } from '@/components/dialog-modal';

import { useAssetPendingChangesGuard } from '@/hooks/asset-pending-changes-navigation.hooks';
import { useAssetParams } from '@/hooks/asset.hooks';
import { getAppConfig } from '@/utils/window.utils';

import styles from './styles.module.scss';

interface Props {
    visible: boolean;
    onClose: () => void;
}

export const AssetExportModal = ({ visible, onClose }: Props) => {
    const { assetId } = useAssetParams();
    const guardPendingChanges = useAssetPendingChangesGuard();
    const config = getAppConfig();
    const { country, language } = getCountryLanguage();
    const [exportArticles, setExportArticles] = useState<boolean>(false);
    const [exportCustomer, setExportCustomer] = useState<boolean>(false);

    const exportAsset = () => {
        const exportTypes: string[] = [];

        if (exportArticles) {
            exportTypes.push('items');
        }

        if (exportCustomer) {
            exportTypes.push('customer');
        }

        /* v8 ignore next 3 */
        if (exportTypes.length === 0) {
            return;
        }

        guardPendingChanges(() => {
            globalThis.location.href = `${config.cartDomain}/${country}/${language}/${config.cartPath}/import/${assetId}/${exportTypes.join(',')}`;
        });
    };

    return (
        <DialogModal
            visible={visible}
            onClose={onClose}
            title={translate('dialog_export_order_title', {
                number: assetId,
            })}
            primaryButtonProps={{
                text: translate('dialog_modal_footer_confirm'),
                onClick: exportAsset,
                disabled: !exportArticles && !exportCustomer,
            }}
            secondaryButtonProps={{ text: translate('dialog_modal_footer_cancel'), onClick: onClose }}
        >
            <div className={styles.modal_content}>
                <Paragraph>{translate('dialog_export_order_body')}</Paragraph>
                <Checkbox
                    id="export-articles-check"
                    checked={exportArticles}
                    value={String(exportArticles)}
                    subtle
                    label={translate('dialog_export_order_articles')}
                    onChange={() => {
                        setExportArticles(!exportArticles);
                    }}
                />
                <Checkbox
                    id="export-customer-check"
                    checked={exportCustomer}
                    value={String(exportCustomer)}
                    subtle
                    label={translate('dialog_export_order_customer')}
                    onChange={() => {
                        setExportCustomer(!exportCustomer);
                    }}
                />
            </div>
        </DialogModal>
    );
};
